import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Setting } from 'src/app/modules/entities/setting';
import { SettingService } from 'src/app/modules/services/setting.service';
import { url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-end-register',
  templateUrl: './end-register.component.html',
  styleUrls: ['./end-register.component.css']
})
export class EndRegisterComponent implements OnInit {

  constructor(private settingService: SettingService, private router: Router, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.queryParams.subscribe({
      next: param => {
        if (param['long-message'] === 'true') {
          this.longMessage = true;
        }
      }
    })
   }

  registrationNumber: string | null = null;
  longMessage: boolean = false;
  isNumberEmpty: boolean = true;

  ngOnInit() {
    this.settingService.getRegistrationNumber().subscribe(response => {
      this.isNumberEmpty = response.status === 'success' ? false : true;
      this.registrationNumber = (response.data as Setting).value.toString();
    }

    ); 
  }

  contact() {
    let contactUrl = 'https://api.whatsapp.com/send?phone=' + this.registrationNumber + '&text=Hola%2C+me+acabo+de+registrar+en+MuyComplacientes';
    window.open(contactUrl, '_blank');
  }

  goHome() {
    this.router.navigate([url['home']]);
  }

}
